export default "__VITE_ASSET__d72c8803__"